import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "What areas do you provide cleaning services in?",
    a: "We provide residential and commercial cleaning services across Iqaluit and the territory of Nunavut — including Apex, Niaqunngut, Tundra Valley, Lower Base, Happy Valley and Road to Nowhere.",
  },
  {
    q: "Do you offer both residential and commercial cleaning?",
    a: "Yes. We offer commercial cleaning for offices, retail stores, medical clinics, schools and government buildings, as well as residential move-in and move-out deep cleaning for homeowners, tenants and property managers.",
  },
  {
    q: "How do I get a quote?",
    a: "Call us at +1 (867) 222-3259, email iqaluitcleaners@gmail.com, or fill out the Request a Quote form on this page. We'll send you a free, no-obligation quote within one business day.",
  },
  {
    q: "Can you schedule recurring cleaning?",
    a: "Absolutely. We offer flexible daily, weekly and monthly scheduled cleaning that fits around your home or business — plus one-time deep cleans whenever you need them.",
  },
  {
    q: "What's included in a move-out cleaning?",
    a: "Our move-out cleaning includes deep cleaning of all rooms, kitchen degreasing, bathroom descaling and disinfecting, cleaning inside cabinets and closets, baseboard and trim cleaning, floor washing, interior windows, and removal of garbage and debris — ideal for recovering deposits or preparing a property for sale.",
  },
];

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      aria-labelledby="faq-heading"
      className="py-24 bg-white"
    >
      <div className="max-w-3xl mx-auto px-5 lg:px-8">
        <div className="text-center">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#2563eb]">
            FAQ
          </span>
          <h2
            id="faq-heading"
            className="font-display mt-4 text-3xl sm:text-4xl font-extrabold tracking-tight text-[#0f2452]"
          >
            Frequently asked questions
          </h2>
          <p className="mt-4 text-lg text-slate-600">
            Everything you need to know about cleaning services in Iqaluit &amp;
            Nunavut.
          </p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.5 }}
          className="mt-10"
        >
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((item, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-slate-200"
              >
                <AccordionTrigger className="text-left font-display text-lg font-semibold text-[#0f2452] hover:no-underline hover:text-[#2563eb]">
                  {item.q}
                </AccordionTrigger>
                <AccordionContent className="text-[15px] leading-relaxed text-slate-600">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
